import Datetime from './Datetime.jsx'

export default function Date (props) {
  return <Datetime format="dd/MM/yyyy" locale="fr-FR" {...props}/>
}
